const PUBLIC_ASSETS_BASE_URL =
  'https://incrypt-public-assets-global.s3.ap-southeast-2.amazonaws.com';

const encodePathSegment = (segment: string | number) =>
  encodeURIComponent(String(segment));

const getPublicAssetUrl = (
  folder: 'images' | 'tcg-images' | 'user-profile-images'
) => {
  return (...pathSegments: Array<string | number>) =>
    `${PUBLIC_ASSETS_BASE_URL}/${folder}/${pathSegments
      .map(encodePathSegment)
      .join('/')}`;
};

export const imageAssetUrl = getPublicAssetUrl('images');
export const profileImageAssetUrl = getPublicAssetUrl('user-profile-images');
